import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Drawer from '@material-ui/core/Drawer';
import React from "react";
import { authorizationActionCreators } from "../../store/actions/authorization";
import { ReactComponent as MenuIcon } from './images/menu_icon.svg';
import { ReactComponent as CloseIcon } from './images/close_icon.svg';
import styles from "./styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import classnames from 'classnames';

export default React.memo((props) => {
  const dispatch = useDispatch();
  const [ menuState, setMenuState ] = React.useState(false);

  const toggleMenu = () => setMenuState(!menuState);

  const logout = React.useMemo(() => {
    return () => {
      dispatch(authorizationActionCreators.logout());
    };
  }, [ dispatch ]);

  const isUserLoggedIn = useSelector((state) => !!state.authorization?.iat);

  return (
    <AppBar
      position="static"
      // className={styles.root}
      className={classnames({
        [styles.root]: isUserLoggedIn,
        [styles.rootBlue]: !isUserLoggedIn,
      })}
    >
      <Toolbar>
        {
          isUserLoggedIn
            ? (
              <>
                <Button
                  color="inherit"
                  onClick={toggleMenu}
                  className={styles.menuButton}
                >
                  <MenuIcon />
                </Button>
                <a className={styles.logo} href={"https://ctgride.com"} />
              </>
            )
            : (
              <Button color="inherit" component={"a"} href={"https://ctgride.com"}>
                Home
              </Button>
            )
        }
        <Typography variant="h6" className={styles.title}>
        </Typography>
        {
          isUserLoggedIn &&
            <>
              <Button color="inherit" onClick={logout}>
                LOG OUT
              </Button>
            </>
        }
      </Toolbar>
      <Drawer
        anchor="left"
        open={menuState}
        onClose={toggleMenu}
        classes={{
          paper: styles.paper,
        }}
      >
        <CloseIcon onClick={toggleMenu} className={styles.closeButton}/>
        <div className={styles.menuTitle}>
          For full functionality please use
          our apps:
        </div>
        <div className={styles.appBlock}>
          <div className={styles.appBlockItem}>
            <a href='https://apps.apple.com/us/app/id1505323247'>
              <img src={require('./images/app_store_badge.png')}
                   srcSet={`
                    ${require('./images/app_store_badge@2x.png')} 2x,
                    ${require('./images/app_store_badge@3x.png')} 3x,
                 `}
              />
            </a>
          </div>
          <div className={styles.appBlockItem}>
            <a href='https://play.google.com/store/apps/details?id=com.ctg.ride&hl=en&utm_source=CTGRide%20website'>
              <img src={require('./images/google-play-badge.jpg')}
                 srcSet={`
                    ${require('./images/google-play-badge@2x.jpg')} 2x,
                    ${require('./images/google-play-badge@3x.jpg')} 3x,
                 `}
              />
            </a>
          </div>
        </div>
      </Drawer>
    </AppBar>
  );
});
